const types = ['OmLuckyWheel', 'OmScratchCard', 'OmPickAPresent'];

export default types;
